import { FormValidationRule } from "../types";

const dateRangeRules: FormValidationRule = (c, v) => {
    let valid = true;
    if (
        c.type === "boi_date_range" &&
        v &&
        c.inputs &&
        (v[c.inputs[0].id] === "" || v[c.inputs[1].id] === "")
    ) {
        valid = false;
    }
    return [valid, ""];
};

export default dateRangeRules;
